import React from "react";

const NotFoundMessage = ({ message = "Player not found." }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center text-gray-500">
      {message}
    </div>
  );
};

export default NotFoundMessage;
